import { render } from "./ScrollTopButton.vue?vue&type=template&id=4e161461&scoped=true"
import script from "./ScrollTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollTopButton.vue?vue&type=script&lang=js"

import "./ScrollTopButton.vue?vue&type=style&index=0&id=4e161461&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e161461"]])

export default __exports__